export enum ApprovalType {
  purchaseOrder,
  standardProductChange,
  bundleUpdate,
  stockLevelChange,
  priceChange
}

export const getApprovalTextFromType = (type: ApprovalType) => {
  switch (type) {
    case ApprovalType.purchaseOrder:
      return 'Purchase Order';
    case ApprovalType.standardProductChange:
      return 'Change Standard Products';
    case ApprovalType.bundleUpdate:
      return 'Updated Bundle';
    case ApprovalType.stockLevelChange:
      return 'Stock Level Change';
    case ApprovalType.priceChange:
      return 'Price Change';
  }
};

// TODO
export interface Approval {
  id: string;
  date: Date;
  requestedBy: string;
  type: ApprovalType;
  approvalNeeded: boolean;
}

const TEMP_APPROVAL_DATA: Approval[] = [
  {
    id: '1',
    date: new Date(),
    requestedBy: 'Phil',
    type: ApprovalType.purchaseOrder,
    approvalNeeded: true
  }
];

export const useApprovals = () => {
  return TEMP_APPROVAL_DATA;
};
